import { Settings2 } from 'lucide-react'

import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { Switch } from '@/components/ui/switch'

import { CarrierService } from '@/types/shipping'

export const CarrierServices = () => {
  // Mock data
  const carriers: CarrierService[] = [
    {
      id: '1',
      name: 'FedEx',
      carrier: 'fedex',
      enabled: true,
      services: ['FedEx Ground', 'FedEx 2Day', 'FedEx Priority Overnight'],
    },
    {
      id: '2',
      name: 'UPS',
      carrier: 'ups',
      enabled: true,
      services: ['UPS Ground', 'UPS 2nd Day Air', 'UPS Next Day Air'],
    },
    {
      id: '3',
      name: 'USPS',
      carrier: 'usps',
      enabled: false,
      services: ['Priority Mail', 'First Class', 'Priority Mail Express'],
    },
    {
      id: '4',
      name: 'DHL Express',
      carrier: 'dhl',
      enabled: false,
      services: ['DHL Express Worldwide'],
    },
  ]

  return (
    <ul className="divide-y divide-border-subtle border-t border-border-subtle">
      {carriers.map((carrier) => (
        <li key={carrier.id} className="flex flex-col gap-3 p-4 sm:flex-row sm:items-start sm:justify-between">
          <div className="min-w-0 space-y-2">
            <div className="flex flex-wrap items-center gap-2">
              <p className="text-sm font-medium text-ink">{carrier.name}</p>
              <Badge tone={carrier.enabled ? 'success' : 'soft'}>
                {carrier.enabled ? 'Connected' : 'Not connected'}
              </Badge>
            </div>
            {carrier.enabled && (
              <div className="flex flex-wrap gap-1.5">
                {carrier.services.map((service) => (
                  <Badge key={service} tone="outline">
                    {service}
                  </Badge>
                ))}
              </div>
            )}
          </div>

          <div className="flex shrink-0 items-center gap-3">
            {carrier.enabled ? (
              <Button variant="secondary">
                <Settings2 />
                Configure
              </Button>
            ) : (
              <Button variant="secondary">Connect</Button>
            )}
            <Switch aria-label={`${carrier.name} enabled`} checked={carrier.enabled} />
          </div>
        </li>
      ))}
    </ul>
  )
}
